import { RootState } from "../../../common/state";
import { useAppSelector } from "../../../common/state/hooks";
import { Status } from "../../../helper/cloudcore/response/models/body";

export const useGadgetInstallationProgress = () => {
    const deviceData = useAppSelector((state: RootState) => state.installedGadgetSlice.deviceData);

    const checkInstallationStatus = (statusToCheck: Array<Status>, callback: Function, params: Array<any>) => {
        outerLoop: for (const deviceId in deviceData) {
            const record = deviceData[deviceId];
            for (const gadgetId in record) {
                const currentStatus = record[gadgetId];
                if(statusToCheck.includes(currentStatus.status)) {
                    callback(...params);
                    break outerLoop;
                }
            }
        }
    };

    return {
        checkInstallationStatus
    }
}